import TipoInvestimento from '../../spa/tipo-investimento/TipoInvestimento';

export default {
  path: 'tipo-investimento',
  name: 'tipo-investimento',
  component: TipoInvestimento,
};
